/** 分享链接（公开只读）API 客户端。 */

export interface ShareCapabilityPack {
  id: string;
  name: string;
  kind: string;
  framework?: string | null;
  version: string;
  state: string;
  locale?: string | null;
  manifest?: Record<string, unknown>;
}

export interface ShareSessionMessage {
  role: string;
  content: string;
  message_type?: string | null;
  created_at?: string | null;
}

export interface ShareSession {
  id: string;
  session_type: string;
  status: string;
  created_at?: string | null;
  ended_at?: string | null;
  messages: ShareSessionMessage[];
}

export interface ShareEvalRun {
  suite_id?: string;
  version?: string;
  run_at?: string;
  total?: number;
  passed?: number;
  pass_rate?: number;
  composite_score?: number;
}

export interface ShareEvalReport {
  artifact: { id: string; name: string; kind: string; version: string };
  runs: ShareEvalRun[];
}

export interface SharedViewData {
  resource_type: 'capability_pack' | 'session' | 'eval_report';
  created_at?: string | null;
  expires_at?: string | null;
  capability_pack?: ShareCapabilityPack;
  session?: ShareSession;
  eval_report?: ShareEvalReport;
}

export type SharedViewResult =
  | { status: 'ok'; data: SharedViewData }
  | { status: 'expired' }
  | { status: 'notfound' }
  | { status: 'error'; message: string };

/**
 * 读取公开分享页数据。
 *
 * 公开页面用原生 fetch、不携带任何认证头：axios 实例的响应拦截器会把 401
 * 未登录访客重定向到登录页，分享视图必须匿名可达。
 */
export async function getSharedView(token: string): Promise<SharedViewResult> {
  try {
    const res = await fetch(`/api/v1/shares/${encodeURIComponent(token)}`);
    if (res.status === 410) return { status: 'expired' };
    if (res.status === 404) return { status: 'notfound' };
    if (!res.ok) return { status: 'error', message: `加载失败 (HTTP ${res.status})` };
    return { status: 'ok', data: (await res.json()) as SharedViewData };
  } catch (e) {
    const message = (e as { message?: unknown })?.message;
    return { status: 'error', message: typeof message === 'string' && message ? message : '网络错误' };
  }
}
